import {
  take,
  put,
  select,
  takeLatest,
  cancel,
  race,
  call,
} from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import * as workslotRemove from '../requests/workslot-remove-req';
import * as blockslotRemove from '../requests/blockslot-remove-req';
import { SCHEDULE_VALIDATE_TYPES, scheduleValidateActions } from '../validate';
import {
  RECURSION_MODAL_TYPES,
  RECURSION_OPTIONS,
  SCHEDULE_TYPES,
} from '../../../components/ProviderCalendar/constants';
import {
  removeRepeatScheduleAdapter,
  isLastDayOfRepeat,
} from '../../../utils/schedule/repeat-schedule-adapter';
import { selectScheduleTargerProviderId } from '../selectors';

const removeMethodMap = {
  [SCHEDULE_TYPES.WORK]: {
    method: workslotRemove.actions.send,
    modalType: RECURSION_MODAL_TYPES.REMOVE_WORK_SLOT,
  },
  [SCHEDULE_TYPES.BLOCK]: {
    method: blockslotRemove.actions.send,
    modalType: RECURSION_MODAL_TYPES.REMOVE_BLOCK_SLOT,
  },
};

function* removeSchedule({ schedule, recursionOption }) {
  const id = yield select(selectScheduleTargerProviderId);
  const type = get(schedule, '__type');

  const removedSlot = removeRepeatScheduleAdapter(recursionOption, schedule);
  const { method } = removeMethodMap[type] || {};

  if (!removedSlot || !method) yield cancel();

  yield put(method({ id, removedSlot }));
}

function* handleRemoveSchedule({ payload: schedule }) {
  const isRepeatable = get(schedule, 'isRepeatable');
  const type = get(schedule, '__type');
  const { modalType } = removeMethodMap[type] || {};

  if (isRepeatable) {
    yield put(
      scheduleValidateActions.toggleRecursionModal({
        type: modalType,
        lastDay: isLastDayOfRepeat(schedule),
        opened: true,
      }),
    );
    const {
      payload: { option: recursionOption },
    } = yield take(SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION);

    yield call(removeSchedule, { schedule, recursionOption });
    yield cancel();
  }

  yield call(removeSchedule, {
    recursionOption: RECURSION_OPTIONS.CURRENT_DAY,
    schedule,
  });
}

export default function* onRemoveScheduleSaga() {
  yield takeLatest(
    [SCHEDULE_VALIDATE_TYPES.REMOVE_SCHEDULE],
    handleRemoveSchedule,
  );
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/on-remove-schedule-saga.js